const CartAdmin = new class {
  constructor() {
    this.cart = {}
    this._events = {}
    this.counter = document.querySelector('.cart-count-bubble span')
    this.load()
  }
  load(element) {
    fetch(`/cart.js`)
      .then(r => r.json())
      .then(cart => {
        this.cart = cart
        this.dispatch('load', {cart, element})
        if(cart.item_count && !this.counter)  {
          const counter = document.createElement('div')
          this.counter = document.createElement('span')
          counter.classList.add('cart-count-bubble')
          document.querySelector('#cart-icon-bubble.header__icon--cart')
            .appendChild(counter)
          counter.appendChild(this.counter)
        }
        if(this.counter) this.counter.textContent = cart.item_count
      })
  }
  on(event, callback) {
    if(!this._events[event]) this._events[event] = []
    this._events[event].push(callback)
  }
  dispatch(event, payload) {
    if(!this._events[event]) return
    this._events[event].forEach(callback => callback(payload))
  }
}


class ProductMultivariant extends HTMLElement {
  constructor() {
    super()
    this.send = this.querySelector('button')
    this.inputs = [...this.querySelectorAll('input[type="number"]:not(:disabled)')]
    this.send.addEventListener('click', () => this.addToCart())
    this.cartIcon = this.send.firstElementChild
    this.loader = this.send.lastElementChild
    CartAdmin.on('load',(cart) => this.setMax(cart))
  }
  setMax({cart, element}) {
    if(element && element != this) return
    this.inputs.forEach(input => {
      const id = Number(input.dataset.variantId)

      const item = cart.items.find(itm => itm.id === id)

      if(!item) return
      input.max = Number(input.dataset.max) - item.quantity
      if(input.max <= 0) input.disabled = true
    })
  }
  addToCart() {
    // Detectar errores de stock
    const errors = this.inputs.filter(input => {
      if(input.disabled) return false
      const isError = Number(input.value) > Number(input.max)
      if(isError) input.style.borderColor = "red"
      else input.style.borderColor = "#ccc"
      return isError
    })
    if(errors.length > 0) return this.showError({message:"Algunas variantes exceden al máximo"})

    // Obtener el array para actualizar
    const values = this.inputs.filter(input => !input.disabled && Number(input.value) > 0).map(input => ({
      id: Number(input.dataset.variantId),
      quantity: Number(input.value)
    }))
    if(values.length == 0) return

    this.cartIcon.classList.add("hidden")
    this.loader.classList.remove("hidden")
    this.send.disabled = true
    fetch(`/cart/add.js`,{
      method: 'post',
      body: JSON.stringify({items:values}),
      headers: {'content-type':'application/json'}
    })
      .then(res => res.json())
      .then(res => this.showNotification(res))
      .catch(err => this.showError(err))
      .finally(() => {
        this.cartIcon.classList.remove("hidden")
        this.loader.classList.add("hidden")
        this.send.disabled = false
      })
  }
  showNotification(res) {
    this.inputs.forEach(i => i.value = '')
    const message = this.nextElementSibling
    message.innerHTML = `Agregamos las ${res.items.length} variantes a tu carrito. <a href="/cart" style="color: green !important;">Ir al carrito</a>`
    message.style.color = 'green'
    message.style.lineHeight = '1.3'
    CartAdmin.load(this)
  }
  showError(err) {
    const message = this.nextElementSibling
    const show = () => {
      message.textContent = err.message
      message.style.color = 'red'
    }
    if(message.textContent === "") return show()
    message.textContent = ""
    setTimeout(show, 300)
  }
}

window.customElements.define('product-multivariant-selector', ProductMultivariant)